// extracted by mini-css-extract-plugin
module.exports = {"moreInfo":"SpotGuideMoreInfo_moreInfo__Hy39C"};